let ReachTheBottom = function (callback) {
    window.onscroll = function(){
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        //滚动条到底部的条件
        if(scrollTop+windowHeight==scrollHeight){
            //写后台加载数据的函数
            callback()
        }
    }
}
let daQu = function (val) {
    let bq = '北京市/河北省/黑龙江省/吉林省/辽宁省/天津市'
    if (bq.indexOf(val) >= 0) {
        return 'RAD-北区'
    }
    let dq = '安徽省/江苏省/江西省/山东省/上海市/浙江省'
    if (dq.indexOf(val) >= 0) {
        return 'RAD-东区'
    }
    let nq = '福建省/广东省/广西壮族自治区/贵州省/海南省/河南省/云南省'
    if (nq.indexOf(val) >= 0) {
        return 'RAD-南区'
    }
    let xq = '甘肃省/湖北省/湖南省/内蒙古自治区/宁夏回族自治区/青海省/山西省/陕西省/四川省/西藏自治区/新疆维吾尔自治区/重庆市'
    if (xq.indexOf(val) >= 0) {
        return 'RAD-西区'
    }
}
export {
    ReachTheBottom,
    daQu
}
